import { render, staticRenderFns } from "./RevisionsList.vue?vue&type=template&id=958066e0&scoped=true"
import script from "./RevisionsList.vue?vue&type=script&lang=js"
export * from "./RevisionsList.vue?vue&type=script&lang=js"
import style0 from "./RevisionsList.vue?vue&type=style&index=0&id=958066e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958066e0",
  null
  
)

export default component.exports